export default __webpack_public_path__ + "static/media/siteLogo.123b8fbb.png";